// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivitySection_wrapper__PMg79","title":"ActivitySection_title__8aLgO","container":"ActivitySection_container__6fp1F"};